import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { CommonModule, DOCUMENT, NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { DialogStateService } from '../../../providers/dialog-state.service'
import { DeviceDetectorService } from 'ngx-device-detector';
import { PipeModule } from 'src/pages/pages/pipe.module';
import { HomeService } from 'src/providers/home.service';
import { CAT2025JSONIDService } from 'src/providers/cat-2025.service';


@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule]
})

export class LeadFormDialog {
  stepVal: any = 1;
  userDetailsForm!: FormGroup;
  targetIIM: any;
  howPrepared: any;
  courseInterested: any;
  formSubmitted: boolean = false;
  constructor(public dialogRef: MatDialogRef<LeadFormDialog>, public formBuilder: FormBuilder,
    public coursesService: CAT2025JSONIDService, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public dashboardService: HomeService, @Inject(DOCUMENT) public dom: any,
    public deviceService: DeviceDetectorService
  ) {
    this.userDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      currentstatus: ['', Validators.required],
    })

    if (this.sessionStorage.getItem('leadObj')) {
      this.leadSubmitted = true;
    }

  }



  step1(val: any) {
    this.targetIIM = val;

  }

  gotolink(val: any) {
    window.open(val, '_blank')
  }

  step2(val: any) {
    this.seeYourself = val;

  }

  step3(val: any) {
    this.howPrepared = val;

  }

  step4(val: any) {
    this.courseInterested = val;

  }
  page_loaction: any;

  addInternalCRMLead1() {
    let medium: any;
    let source: any;
    let campaign: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
        if (item.includes('utm_source')) {
          source = item.split('=')[1]
        }
        if (item.includes('utm_campaign')) {
          campaign = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "name": this.userDetailsForm.value.name,
      "firstName": this.userDetailsForm.value.name,
      "phone": this.userDetailsForm.value.mobile,
      "email": this.userDetailsForm.value.email,
      "countryCode": 91,
      "source": "Website",
      "medium": "Popup",
      "campaign": 'Personalized Counselling',
      "orgId": "66dec57ce200bc89284602d6",
      "uid": '66dec57ce200bc89284602d6',
      "userId": 9999,
      "registrationDate": new Date().valueOf(),
      "pageLocation": this.dom.URL,
      "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
      "registrationDevice": this.deviceService.deviceType,
      "customFields": {
        "exam": 'CAT',
        "examCategory": 'MBA',
        "examTargetYear": this.userDetailsForm.value.currentstatus,
        "leadPriority": "Platinum",
        "q1": this.targetIIM ? this.targetIIM : '',
        "q2": this.seeYourself ? this.seeYourself : '',
        "q3": this.howPrepared ? this.howPrepared : ''
      },
      "ipAddress": this.sessionStorage.getItem('ipAddress'),
      courseInterestedIn: this.courseInterested ? this.courseInterested : '',
      dataSource: [
        {
          utmSource: source,
          utmMedium: medium,
          utmCampaign: campaign,
          utmAdContent: "",
          "source": "Website",
          "medium": "Popup",
          "campaign": 'Personalized Counselling',
          adContent: "",
          "pageLocation": this.dom.URL,
          browser: this.deviceService.browser,
          browser_version: this.deviceService.browser_version,
          device: this.deviceService.device,
          deviceType: this.deviceService.deviceType,
          orientation: this.deviceService.orientation,
          os: this.deviceService.os,
          os_version: this.deviceService.os_version,
          platformId: this.deviceService['platformId'],
          ua: this.deviceService.ua,
          userAgent: this.deviceService.userAgent,
          "ipAddress": this.sessionStorage.getItem('ipAddress'),
          courseInterestedIn: this.courseInterested ? this.courseInterested : ''
        },
      ],
    }

    this.dashboardService.addCRMLead(reqObj).subscribe(res => {
      if (res.success) {

      } else {
      }
    }, err => {
      if (err.statusText == 'Unknown Error') {
        this.callBackLead(reqObj)
      }
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {

    })
  }

  leadId: any;
  seeYourself: any;

  nextStep() {
    if (this.stepVal == 1) {
      this.formSubmitted = false;
      if (this.userDetailsForm.valid) {
        let reqObj = {
          "name": this.userDetailsForm.value.name,
          "email": this.userDetailsForm.value.email,
          "phone": this.userDetailsForm.value.mobile,
          "currentStatus": this.userDetailsForm.value.currentstatus,
        }
        this.coursesService.saveUserLEadForm(reqObj).subscribe(res => {
          if (res.success) {
            this.leadId = res.data.batch;
            this.stepVal++;
            this.addInternalCRMLead1()
            // this.sessionStorage.setItem('leadObj', JSON.stringify(res.data.batch))
            // this.leadId['name'] = this.userDetailsForm.value.name;
            // this.leadId['email'] = this.userDetailsForm.value.email;
            // this.leadId['phone'] = this.userDetailsForm.value.mobile;
            // this.leadId['currentStatus'] = this.userDetailsForm.value.currentstatus;
            // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            // this.stepVal++;
          }
        })
      } else {
        this.formSubmitted = true;
      }
    } else {
      if (this.stepVal == 2) {
        if (this.targetIIM) {
          let reqObj = {
            "targetIIM": this.targetIIM
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.leadId['targetIIM'] = this.targetIIM;
              this.stepVal++;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 3) {
        if (this.seeYourself) {
          let reqObj = {
            "seeYourself": this.seeYourself
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.stepVal++;
              this.leadId['seeYourself'] = this.seeYourself;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 4) {
        if (this.howPrepared) {
          let reqObj = {
            "howPrepared": this.howPrepared
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.stepVal++;
              this.leadId['howPrepared'] = this.howPrepared;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 5) {
        if (this.courseInterested) {
          let reqObj = {
            "step4": this.courseInterested
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.leadSubmitted = true;
              this.leadId['step4'] = this.courseInterested;
              this.addInternalCRMLead1()

              //  this.dialogRef.close(res)
              this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      }
      // this.stepVal++;
    }
  }

  leadSubmitted: boolean = false;

  backStep() {
    this.stepVal--;

  }

  closeModal() {
    this.dialogRef.close()
  }

}

@Component({
  selector: 'app-cat-course-package-mocks',
  templateUrl: './cat-course-package-mocks.component.html',
  styleUrls: ['./cat-course-package-mocks.component.scss'],
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, NgxSliderModule, MatDialogModule, LeadFormDialog, PipeModule]
})

export class CatCoursePackageMocksComponent {

  playVideoFlag: boolean = false;
  // myTarget: any = 98;
  descCount:any = 350;

  @Input('videoLinkMain') videoLinkMain: any;
  @Input('thumbnail') thumbnail: any;
  @Input('myTarget') myTarget: any;
  @Input('courses') courses: any;
  @Input('pageType') pageType: any;


  @Output() getTarget = new EventEmitter<string>()

  options: Options = {
    showTicksValues: true,
    stepsArray: [
      { value: 92, legend: "92" },
      { value: 93, legend: "93" },
      { value: 94, legend: "94" },
      { value: 95, legend: "95" },
      { value: 96, legend: "96" },
      { value: 97, legend: "97" },
      { value: 98, legend: "98" },
      { value: 99, legend: "99" },
      { value: 100, legend: "100%ile" }
    ]
  };

  productName: any = 'cat full course';

  @ViewChild('startSentinel') startSentinel!: ElementRef;
  @ViewChild('endSentinel') endSentinel!: ElementRef;

  isFixed = false;

  constructor(public courseService: CAT2025JSONIDService, @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public router: Router, public dialog: MatDialog,
    private dialogState: DialogStateService, public deviceService: DeviceDetectorService) { }

  ngOnInit() {
    console.log(this.courses)
    this.getProductDetails()
    if (this.pageType) {
      this.playVideoFlag = true;
    }
  }

    seeMore(){
    this.descCount = this.productDetails.description.length;
  }

  isFixed1: boolean = false;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (this.deviceService.isMobile()) {
      let div1: any = document.getElementById('sectionRef');
      let div: any = document.getElementById('incl-features');

      let div11: any = document.getElementById('slider-div');
      // let div01: any = document.getElementById('incl-features');


      const viewportOffset1 = div1.getBoundingClientRect();
      const top1 = viewportOffset1.top;
      const viewportOffset = div.getBoundingClientRect();
      const top = viewportOffset.top;

      const viewportOffset2 = div11.getBoundingClientRect();
      const top2 = viewportOffset2.top;


      if (top2 < 100) {
        if (top > 0) {
          this.isFixed1 = true
        } else {
          this.isFixed1 = false
        }
      } else {
        this.isFixed1 = false;
      }

      if (top1 < 100) {
        if (top > 0) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      } else {
        this.isFixed = false;
      }
    }

  }

  ngAfterViewInit(): void {
    // Observe when the start sentinel is at (or near) the top of the viewport
    // if (!isPlatformBrowser(this.platformId)) return;

    // this.startObserver = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.boundingClientRect.top <= 700) {
    //       this.isFixed = true;
    //     }
    //   },
    //   {
    //     root: null,
    //     threshold: 0,
    //   }
    // );

    // // Observe when the end sentinel is in view (i.e. section end reached)
    // this.endObserver = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       this.isFixed = false;
    //     }
    //   },
    //   {
    //     root: null,
    //     threshold: 0,
    //   }
    // );

    // this.startObserver.observe(this.startSentinel.nativeElement);
    // this.endObserver.observe(this.endSentinel.nativeElement);
  }

  ngOnDestroy(): void {
    // this.startObserver?.unobserve(this.startSentinel.nativeElement);
    // this.endObserver?.unobserve(this.endSentinel.nativeElement);
  }
  setTarget(target: any) {
    console.log(target)
    // let fill: any = document.querySelector('.slider-fill');
    this.addonListIds = []
    // this.myTarget = target;
    if (this.myTarget == 99) {
      this.addonListIds.push('403')
      this.getTotalPrice()
    } else if (this.myTarget == 100) {
      this.addonListIds.push('403', '439')
      this.getTotalPrice()
    } else if (this.myTarget == 98) {
      this.addonListIds = []

      this.getTotalPrice()
    } else if (this.myTarget < 98) {
      // const dialog = this.dialog.open(TargetSetDialog,{
      //   panelClass: 'leadForm',
      //   width: '100%',
      //   backdropClass: 'custom-backdrop-width',
      //   data:this.myTarget
      // })
      // dialog.afterClosed().subscribe(res=>{
      //   if(res){
      //     this.myTarget = res;
      //     this.setTarget('')
      //   }
      // })
    }
    this.getTarget.emit(this.myTarget)

  }
  addonListIds: any[] = []
  addon(id: any, target: any) {
    if (this.addonListIds.includes(id)) {
      let index: any = this.addonListIds.indexOf(id)
      this.addonListIds.splice(index, 1)
      if (this.addonListIds.length == 0) {
        this.myTarget = 98;
      }
    } else {
      this.addonListIds.push(id)
    }
    if (target) {
      this.myTarget = target;
    } else {
      if (this.addonListIds.length < 3 && !this.addonListIds.includes('316')) {
        this.myTarget = 98 + this.addonListIds.length
      } else {
        this.myTarget = 98 + (this.addonListIds.length - 1)
      }
    }
    this.getTotalPrice()
  }


  productDetails: any;
  productId: any;
  addonList: any[] = [];
  discountAmount: any = 0;
  referralAmount: any = 0;
  getProductDetails() {
    this.courseService.getProductDetails(this.productName).subscribe((res: any) => {
      if (res.success) {
        this.productDetails = res.data[0];
        this.productId = this.productDetails.id;
        this.getTotalPrice()

      }
    })
  }

  priceObj: any;

  getCoursePrice() {

  }

  totalAmount: number = 0;
  getTotalPrice() {
    let total = 0;
    // this.getCoursePrice()
    if (this.addonListIds.length == 0) {
      this.priceObj = this.courses.filter((x: any) => x.id == 753)[0];
      total = this.priceObj.offer_price;

    } else if (this.addonListIds.includes('439') && !this.addonListIds.includes('403') && !this.addonListIds.includes('316')) {
      this.priceObj = this.courses.filter((x: any) => x.id == 755)[0];
      total = this.priceObj.offer_price;

    } else if (this.addonListIds.includes('439') && this.addonListIds.includes('403') && !this.addonListIds.includes('316')) {
      this.priceObj = this.courses.filter((x: any) => x.id == 754)[0];
      total = this.priceObj.offer_price;

    } else if (this.addonListIds.includes('403') && !this.addonListIds.includes('439') && !this.addonListIds.includes('316')) {
      this.priceObj = this.courses.filter((x: any) => x.id == 734)[0];
      total = this.priceObj.offer_price;

    }
    else if (this.addonListIds.includes('316')) {
      this.priceObj = this.courses.filter((x: any) => x.id == 440)[0];
      total = this.priceObj.offer_price;

    }
    this.totalAmount = total;
  }

  gotosection(val: any) {
    if (val == 'feedback') {
      if (this.pageType == 'landing') {
        var elemnt: any = document.getElementById('topper-section')
        elemnt.scrollIntoView({ behavior: "smooth" })
      } else {
        var elemnt: any = document.getElementById(val)
        elemnt.scrollIntoView({ behavior: "smooth" })
      }
    } else {
      var elemnt: any = document.getElementById(val)
      elemnt.scrollIntoView({ behavior: "smooth" })
    }

  }

  buynow() {
    if (this.addonListIds.length == 0) {
      this.router.navigate(['/details/cat-full-course'])
    } else if (this.addonListIds.includes('439') && !this.addonListIds.includes('403') && !this.addonListIds.includes('316')) {
      this.router.navigate(['/details/cat-2025-full-course-iim-abc-practice-batch'])
    } else if (this.addonListIds.includes('439') && this.addonListIds.includes('403') && !this.addonListIds.includes('316')) {
      this.router.navigate(['/details/CAT-2025-full-course-pro'])
    } else if (this.addonListIds.includes('403') && !this.addonListIds.includes('439') && !this.addonListIds.includes('316')) {
      this.router.navigate(['/details/cat-2025-full-course-and-books'])
    }
    else if (this.addonListIds.includes('316')) {
      this.router.navigate(['/details/maha-mba-2025-course'])
    }
  }

  openLeadForm() {
    this.dialogState.setDialogOpen('true');
    this.sessionStorage.setItem('stillConfused', 'true')
    const dialog = this.dialog.open(LeadFormDialog, {
      panelClass: 'leadForm',
      width: '100%',
      backdropClass: 'custom-backdrop-width'
    })
    dialog.afterClosed().subscribe(res => {
      this.dialogState.setDialogOpen('false');
      this.sessionStorage.removeItem('stillConfused')
      // location.reload()
    })
  }


}


